export default __webpack_public_path__ + "static/media/vector2.56faec5e.svg";